import angular from 'angular';

angular
  .module('commonServices')
  .provider('googleMaps', function() {
    this.$get = [
      '$window',
      function($window) {
        return $window.google.maps;
      },
    ];
  })
  .factory('googleMapsSvc', [
    '$q',
    '$timeout',
    '$rootScope',
    'googleMaps',
    'appMessages',
    googleMapsSvc,
  ]);

function googleMapsSvc($q, $timeout, $rootScope, googleMaps, appMessages) {
  var travelModes = [];
  var unitSystems = [];

  travelModes.driving = googleMaps.TravelMode.DRIVING;
  travelModes.bicycling = googleMaps.TravelMode.BICYCLING;
  travelModes.transit = googleMaps.TravelMode.TRANSIT;
  travelModes.walking = googleMaps.TravelMode.WALKING;

  unitSystems.metric = googleMaps.UnitSystem.METRIC;
  unitSystems.imperial = googleMaps.UnitSystem.IMPERIAL;

  var defaults = {
    unitSystem: null,
    durationInTraffic: false,
    avoidHighways: false,
    avoidTolls: false,
  };

  function distanceMatrix(args) {
    var req = angular.copy(defaults, {});
    angular.extend(req, args);
    var deferred = $q.defer();

    var service = new googleMaps.DistanceMatrixService();
    var timer = $timeout(function() {
      deferred.reject('Timeout');
    }, 10000);

    service.getDistanceMatrix(req, function(result, status) {
      $timeout.cancel(timer);
      if (
        status === googleMaps.DistanceMatrixStatus.OK ||
        status === googleMaps.DistanceMatrixStatus.ZERO_RESULTS
      ) {
        $rootScope.$apply(function() {
          if (!result.originAddresses[0]) return deferred.reject(appMessages('mapsOriginNotFound'));
          if (!result.destinationAddresses[0])
            return deferred.reject(appMessages('mapsDestinationNotFound'));

          var res = {
            origin: result.originAddresses[0],
            destination: result.destinationAddresses[0],
          };

          if (result.rows.length && result.rows[0].elements.length) {
            var el = result.rows[0].elements[0];
            res.status = el.status;
            if (el.status === 'OK') {
              res.distance = (el.distance.value / 1000.0).toFixed(2);
              res.distanceText = el.distance.text;
              res.durationMinutes = Math.round(el.duration.value);
              res.durationText = el.duration.text;
            }
          }
          res.originalResult = result;
          return deferred.resolve(res);
        });
      } else {
        $rootScope.$apply(function() {
          return deferred.reject(status);
        });
      }
    });

    return deferred.promise;
  }

  return {
    getDistanceMatrix: function(origin, destination, args) {
      if (typeof args === 'undefined' || args === null) args = {};
      args.travelMode = travelModes[args.travelMode] || googleMaps.TravelMode.DRIVING;
      args.unitSystem = unitSystems[args.unitSystem] || googleMaps.UnitSystem.METRIC;
      args.origins = [].concat(origin);
      args.destinations = [].concat(destination);
      return distanceMatrix(args);
    },
  };
}
